import {type ReactNode, createContext, useContext, useMemo, useState} from "react";

type PennylaneRecapModalContextValue = {
  isRecapModalOpen: boolean;
  openRecapModal: () => void;
  closeRecapModal: () => void;
};

const PennylaneRecapModalContext = createContext<PennylaneRecapModalContextValue | null>(null);

/**
 * État d'ouverture de la modal Récap Pennylane (#651) — modale GLOBALE de
 * l'app, partagée par l'écran de choix de Facturation et le nudge #650.
 * Monté une fois dans `RootLayout`, au-dessus à la fois du
 * cascade `AppModals` (qui rend la modal) et des routes (dont les
 * descendants l'ouvrent via `usePennylaneRecapModal`).
 */
export function PennylaneRecapModalProvider({children}: {children: ReactNode}) {
  const [isRecapModalOpen, setIsRecapModalOpen] = useState(false);

  const value = useMemo<PennylaneRecapModalContextValue>(
    () => ({
      isRecapModalOpen,
      openRecapModal: () => setIsRecapModalOpen(true),
      closeRecapModal: () => setIsRecapModalOpen(false),
    }),
    [isRecapModalOpen]
  );

  return (
    <PennylaneRecapModalContext.Provider value={value}>
      {children}
    </PennylaneRecapModalContext.Provider>
  );
}

export function usePennylaneRecapModal(): PennylaneRecapModalContextValue {
  const ctx = useContext(PennylaneRecapModalContext);
  if (!ctx) {
    throw new Error("usePennylaneRecapModal must be used within a PennylaneRecapModalProvider");
  }
  return ctx;
}
